module.exports = __webpack_public_path__ + "img/212.42204a92.jpg";